<script>
export default {
  name: "Primary logo",
  props: {
    setWidth: {
      type: String,
      default: "auto",
    },
    setHeight: {
      type: String,
    },
    secondary: Boolean,
  },
};
</script>

<template>
  <router-link
    v-if="!secondary"
    to="/"
    :style="{
      width: setWidth,
      height: setHeight,
    }"
    class="primaryLogo"
  >
  </router-link>
  <router-link
    v-if="secondary"
    to="/"
    :style="{
      width: setWidth,
      height: setHeight,
    }"
    class="secondaryLogo"
  >
  </router-link>
</template>

<style scoped>
.primaryLogo,
.secondaryLogo {
  display: block;
  background-image: url("../../assets/logosPixGG/logo-light-pixgg.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  text-decoration: none;
}

.secondaryLogo {
  background-image: url("../../assets/logosPixGG/logo-darkmode.svg");
}

.checkout .secondaryLogo {
  background-image: url("../../assets/logosPixGG/logo-light-pixgg.svg");
  background-color: #141943;
  background-color: #fff;
  background-size: 110px;
  border-radius: 10px;
}

.primaryLogo::after,
.secondaryLogo::after {
  display: none;
}

.primaryLogo::after {
  display: none;
}
</style>
